import {observer} from 'mobx-react-lite';
import React from 'react';
import {IntercomProviderProps as IntercomProviderPropsBase} from 'react-use-intercom';

import {IntercomProviderComponent} from '../../components/intercom/intercom-provider.component';
import intercomConfig from '../../configs/intercom-config';
import {useAllUnits} from '../../hooks/units/use-all-units';
import {useStores} from '../../hooks/use-stores';
import {Unit} from '../../interfaces/entities/unit.interface';
import {getToken} from '../../utils/auth';

interface IntercomProviderProps extends Omit<IntercomProviderPropsBase, 'appId'> {
  appId?: string;
}

const IntercomProvider = observer((props: IntercomProviderProps) => {
  const {authStore} = useStores();
  const {items: units, loading: loadingUnits} = useAllUnits();

  return (
    <IntercomProviderComponent
      {...props}
      appId={intercomConfig.applicationId}
      user={authStore.me}
      loadingUser={authStore.loading}
      units={units as Unit[]}
      loadingUnits={loadingUnits}
    />
  );
});

export const IntercomProviderContainer = (props: IntercomProviderProps) => {
  const authToken = getToken();
  if (!authToken) {
    return <IntercomProviderComponent {...props} appId={intercomConfig.applicationId} loadingUser loadingUnits />;
  }

  return <IntercomProvider {...props} />;
};
